var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FloatInput',_vm._g(_vm._b({staticClass:"app-float-input",attrs:{"outlined":"","dense":""}},'FloatInput',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }